import { useFeatureIsOn } from '@zen/FeatureFlag';

import { usePurchaseOrderTableVersion } from './PurchaseOrderTableVersionContext';
import { PurchaseOrderTableVersion } from './types';

const useActivePurchaseOrderTableVersion = (): PurchaseOrderTableVersion => {
  const isNewPurchaseOrderTableEnabled: boolean = useFeatureIsOn('new-po-table');
  const { tableVersion } = usePurchaseOrderTableVersion();

  return isNewPurchaseOrderTableEnabled ? tableVersion : PurchaseOrderTableVersion.CLASSIC;
};

export default useActivePurchaseOrderTableVersion;
